export default __webpack_public_path__ + "static/media/Train_Station_Students.fe02e243.jpg";